import AppForm from '../app-components/Form/AppForm';

Vue.component('app-office-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                code:  '' ,
                name:  '' ,
                
            }
        }
    }

});